module.exports = __webpack_public_path__ + "img/baseStation.c4c8b1c2.png";